import useHasAdminPermission from 'src/hooks/useHasAdminPermission'
import useIsDevUser from 'src/hooks/useIsDevUser'

/**
 * Whether the user sees what the chat runs on: the real model names and the
 * cost in dollars. Developers and admins do; everyone else sees animals and
 * credits. A display switch only -- the usage route answers in dollars for
 * everyone.
 */
const useSeesChatInternals = (): boolean => {
  const { isDevUser } = useIsDevUser()
  const { hasAdminPermission } = useHasAdminPermission()

  return isDevUser || hasAdminPermission
}

export default useSeesChatInternals
